(function () {
    "use strict";

    function isMobileDevice() {
        const isNarrowScreen = window.innerWidth <= 768;
        const hasPointerCoarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
        const hasHoverNone = window.matchMedia && window.matchMedia("(hover: none)").matches;
        const isMediaQueryMobile = hasPointerCoarse || hasHoverNone;

        const userAgent = navigator.userAgent.toLowerCase();
        const mobilePatterns = [
            "mobile",
            "android",
            "iphone",
            "ipad",
            "ipod",
            "blackberry",
            "windows phone",
            "opera mini",
        ];
        const hasMatchingUserAgent = mobilePatterns.some((pattern) => userAgent.includes(pattern));

        return isNarrowScreen || isMediaQueryMobile || hasMatchingUserAgent;
    }

    function loadHubSpotForDesktop() {
        const isMobile = isMobileDevice();

        if (!isMobile) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.id = "hs-script-loader";
            script.async = true;
            script.defer = true;
            script.src = "https://js-na1.hs-scripts.com/40223960.js";
            document.head.appendChild(script);

            window.hsConversationsSettings = {
                loadImmediately: false,
            };

            if (window.HubSpotConversations) {
                window.HubSpotConversations.widget.remove();
            }
        }
    }

    function init() {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", loadHubSpotForDesktop);
        } else {
            loadHubSpotForDesktop();
        }
    }

    init();
})();
